import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Card, Btn } from "@/components/common";
import { Copy } from "lucide-react";

export default function SpokiSettings() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/spoki-settings").then((r) => setC(r.data)); }, []);
  if (!c) return null;
  const save = async (enabled, regenerate = false) => {
    try { setC((await api.put("/spoki-settings", { enabled, regenerate })).data); toast.success(enabled ? "Spoki attivo" : "Spoki disattivato"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/public/spoki/availability?checkin=AAAA-MM-GG&checkout=AAAA-MM-GG`;
  const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copiato"); };
  return (
    <Card className="p-5 space-y-3 lg:col-span-2" data-testid="spoki-settings">
      <label className="flex items-center gap-2 font-heading font-bold text-slate-900 cursor-pointer">
        <input type="checkbox" checked={!!c.enabled} onChange={(e) => save(e.target.checked)} className="h-4 w-4 accent-sky-700" data-testid="spoki-toggle" />
        Spoki: lettura disponibilità dal calendario
      </label>
      <p className="text-xs text-slate-500">Quando è attivo, Spoki può chiedere all'app quante camere sono libere nelle date del cliente. Spento = nessun accesso.</p>
      {c.enabled && (
        <div className="text-xs space-y-1.5" data-testid="spoki-details">
          <div className="flex flex-wrap items-center gap-2"><b>Indirizzo (GET):</b> <span className="break-all text-slate-600">{url}</span><button onClick={() => copy(url)} className="text-sky-700"><Copy size={13} /></button></div>
          <div className="flex flex-wrap items-center gap-2"><b>Header X-Api-Key:</b> <span className="font-mono text-slate-600" data-testid="spoki-key">{c.api_key}</span><button onClick={() => copy(c.api_key)} className="text-sky-700"><Copy size={13} /></button>
            <Btn variant="secondary" data-testid="spoki-regenerate" onClick={() => save(true, true)}>Rigenera chiave</Btn></div>
          <p className="text-slate-400">In Spoki: Automazioni → azione "Invia Webhook" / strumento AI con chiamata API, metodo GET, header X-Api-Key con la chiave qui sopra.</p>
        </div>
      )}
    </Card>
  );
}
